import { API_FORBIDDEN_RESPONSE_MESSAGE } from 'Config/Errors';

export const isForbiddenResponseError = (error: Error): boolean => error.message === API_FORBIDDEN_RESPONSE_MESSAGE;
